
import Header from "../Common/Header";
import Footer from "../Common/Footer";
function Insurance() {
  return (
   <>
   <Header />
    {/* Start Our Features area */}
    <div className="features-area pt-100 pb-70 bgcolor">
      <div className="container">
        <div className="section-title">
          
          <h2>Insurance Services</h2>
        </div>
       
        <div className="row">
        <div className="col-lg-12 col-sm-12 col-md-12">
          <div class="section-title leftalign">
            
        <span className="">Insurance Services </span>
          </div>
          </div>
          </div>
          <div className="row parent">
          <div className="col-lg-3 col-sm-6 col-md-6">

          <div class="services-three-card">
          <div className="child">
                        <div class="services-card d-flex align-items-center">
                            <div class="services-icon bg-icon-color">
                            <img src="assets/images/proicon/moter-insurance.svg"  />
                            </div>
                            <h3>Motor Insurance
                            </h3>
                        </div>
                        <p>Get Additional Protection On Your Car With Add Ons

</p>
                        <a href="#" class="default-btn">Apply Now</a>
                    </div>
</div>


          </div>
          <div className="col-lg-3 col-sm-6 col-md-6">
          <div class="services-three-card">
          <div className="child">
                        <div class="services-card d-flex align-items-center">
                            <div class="services-icon bg-icon-color">
                            <img src="assets/images/proicon/life-insurance-policy.svg"  />
                            </div>
                            <h3>Life Insurance
                            </h3>
                        </div>
                        <p>1 Cr Life Cover @Rs 473/Month* Cheapest Prices,


                        </p>
                        <a href="#" class="default-btn">Apply Now</a>
                    </div>

</div>
          </div>
          <div className="col-lg-3 col-sm-6 col-md-6">
          <div class="services-three-card">
          <div className="child">
                        <div class="services-card d-flex align-items-center">
                            <div class="services-icon bg-icon-color">
                            <img src="assets/images/proicon/health-insurance.svg"  />
                            </div>
                            <h3>Health Insurance
                            </h3>
                        </div>
                        <p>Health insurance plans covers medical expenses

</p>
                        <a href="#" class="default-btn">Apply Now</a>
                    </div>
          </div>
          </div>
          <div className="col-lg-3 col-sm-6 col-md-6">

          <div class="services-three-card">
          <div className="child">
                        <div class="services-card d-flex align-items-center">
                            <div class="services-icon bg-icon-color">
                            <img src="assets/images/proicon/group-insurance.svg"  />
                            </div>
                            <h3>Group Insurance
                            </h3>
                        </div>
                        <p>Group Insurance policy covers a professional



</p>
                        <a href="#" class="default-btn">Apply Now</a>
                    </div>
          
</div>
          </div>



        </div>


      </div>
    </div>
    {/* End Our Features area */}
  
    <Footer />
   </>
  );
}

export default Insurance;
